import { ThemeProvider, Typography } from "@material-ui/core";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { MUIDialog, Theme } from "../../entryes/panel/MUI";
import { plural, tl } from "../../utils";

export const ServicesDisabled: React.FC<{open: boolean}> = (props) => {
  const [open, setOpen] = React.useState(false)
  React.useEffect(() => setOpen(props.open), [props.open]);

  const closeModal = () => {
    setOpen(false);
    window.react_render_services_disabled_modal(false);
  };


  return (
    <MUIDialog 
      maxWidth={'xs'} 
      mobileFullWidth
      className="no1200-step"
      open={open} 
      title={tl("Внимание! Файл не загружен!")}
      closeIconSmall
      onClose={closeModal} 
      actions={[
        [],
        [{
          label: tl("Отмена"),
          btnProps: {
            onClick: closeModal,
          }
        },
        {
          label: tl('Пополнить'),
          btnProps: {
            color:'primary',
            href: `/panel/plan/refill?cost=${Math.abs(+window._user.points)}`
          }
        }]
      ]}
    >
      {
        window._user.isAuthor ?
        <>
          <Typography>{tl("У вас отрицательный баланс за доп услуги.")}</Typography>
          <Typography>{plural("%d баллов",window._user.points)}{' '} <a href="/panel/filestorage">({tl("детализация")})</a></Typography>
          <Typography>{tl("Пополните счет, чтобы загружать файлы")}</Typography>
        </> :
        <Typography>{tl("Загрузка прервана. Обратитесь к автору")}</Typography>

      }
    </MUIDialog>
  )
}



window.react_render_services_disabled_modal = function(open) {
  ReactDOM.render(<ThemeProvider theme={Theme}><ServicesDisabled open={open}/></ThemeProvider>, document.getElementById('react_root_services_disabled'))
}